import QuillEditor from 'components/wysiwig/QuillEditor';
import { Controller, get, useWatch } from 'react-hook-form';

/**
 * HTMLエディタ入力コンポーネント
 */
export default function FormWysiwygEditor(props: {
  // 項目名
  subject?: string;
  // 項目変数名
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // フォームコントロール
  control: any;
  // エラー情報
  errors: any;
  // ツールバーの設定
  toolbar?: ('link' | 'button' | 'image')[];
  // カスタムクラス名
  className?: string;
  // 無効化
  disabled?: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const value = useWatch({
    control: props.control,
    name: props.name, // フィールドの名前
  });

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */
  // useEffect(() => {
  //   console.debug("value", value);
  // }, [value]);

  // useEffect(() => {
  //   console.log("isRequired Change", _getRules(props.required));
  //   setRulesState(_getRules(props.required));
  // }, [props.required]);

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */

  return (
    <>
      <Controller
        name={props.name}
        control={props.control}
        defaultValue={''}
        rules={
          props.required
            ? {
                required: '必須項目です。',
              }
            : {}
        }
        render={({ field }) => {
          return (
            <>
              {props.subject && (
                <label className="form-label">
                  {props.subject}
                  {props.requiredMark && (
                    <span className={props.required ? 'must' : 'any'}>
                      {props.required ? ' *' : ''}
                    </span>
                  )}
                </label>
              )}
              <QuillEditor
                value={value}
                onChange={v => {
                  // <p><br></p> など空に見えるHTMLを空文字に変換
                  const cleanValue = v === '<p><br></p>' ? '' : v;
                  field.onChange(cleanValue);
                }}
                placeholder={props.placeholder}
                readOnly={props.readOnly || props.disabled}
                toolbar={props.toolbar}
                className={`
                  ${props.className ?? ''}
                  ${props.disabled ? 'disabled' : ''}
                  ${get(props.errors, props.name) ? 'is-invalid' : ''}
                `.trim()}
              />
              {get(props.errors, props.name) && (
                <p className="error">{get(props.errors, props.name)?.message}</p>
              )}
            </>
          );
        }}
      />
    </>
  );
}
